const reg4000 = /^[1-9]\d{1,2}$|^[1-3]\d{0,3}$|^[1-9]$|^4[0]{0,3}$/; // 1-4000
const reg0_4000 = /^[1-9]\d{1,2}$|^[1-3]\d{0,3}$|^[0-9]$|^4[0]{0,3}$/; // 0-4000
interface KingParamsReg{
  m: RegExp,
  w: RegExp,
  h: RegExp,
  q: RegExp,
  F: RegExp,
  r: RegExp,
  c: RegExp,
  f: RegExp,
  s: RegExp,
  cox: RegExp,
  coy: RegExp,
  rotate: RegExp,
  et: RegExp,
  etw: RegExp,
  eth: RegExp,
  etc: RegExp
}
const reg:KingParamsReg = {
  m: /^[0-2]$/,
  w: reg4000,
  h: reg4000,
  q: /^[0-9]\d?$|^1[0]{0,2}$/,
  F: /webp|jpg|jpeg|gif|png|WEBP|JPG|PNG|GIF|JPEG/,
  r: /^[0-2]$/,
  c: /^[0-1]$/,
  f: /^[0-1]$/,
  s: /^[0-1]$/,
  cox: reg0_4000,
  coy: reg0_4000,
  rotate: /^[1-9]\d?$|^[1-2]\d{2}$|^3[0-5]\d?$|^360$/,
  et: /^[0-1]$/,
  etw: reg4000,
  eth: reg4000,
  etc: /^[0-9a-fA-F]{6}$|transparent/
};
export default reg;
